/**
 @format
 @flow
 */

import React from 'react';
import styled from 'styled-components';
import TextStatement from '@ziynx/components/statements';
import Headline from '@ziynx/components/headlines';
import type { TextStatementType } from '@ziynx/flow-types/statements';
import type { Headline as HeadlineType } from '@ziynx/flow-types/headlines';
import CardBase from './CardBase';

export type Props = $ReadOnly<{|
    headline?: HeadlineType,
    width?: string | number,
    height?: string | number,
    data?: Array<TextStatementType>,
|}>

const HeadlineWrapper = styled.div`
    padding-bottom: 24px;
`;

const StatementWrapper = styled.div`
    padding: 32px 48px;
`;

const CardTextStatement = (props: Props): React$Node => {
  const {
    headline, width, height, data, ...rest
  } = props;

  return (
    <>
      {headline
          && (
            <HeadlineWrapper>
              <Headline {...(headline: HeadlineType)} />
            </HeadlineWrapper>
          )}
      <CardBase width={width} height={height} padding={false} {...rest}>
        <StatementWrapper>
          <TextStatement data={data} />
        </StatementWrapper>
      </CardBase>
    </>
  );
};

CardTextStatement.defaultProps = {
  width: undefined,
  height: undefined,
};

export default CardTextStatement;
